import { testDriveMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

export const tedNoPolicies: MockPersona = {
  key: "tedNoPolicies",
  name: "Ted NoPolicies",
  description: "🇺🇸 | No policies | No HDC | No alerts",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "ted@nopolicies.com",
            firstName: "Ted",
            middleName: "",
            lastName: "NoPolicies",
            mailingAddress: {
              line1: "2210 Patterson Fork Road",
              line2: "",
              city: "Chicago",
              state: "IL",
              postalCode: "60601",
              country: "USA",
            },
            preferredPhone: "7735040778",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000027",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: undefined,
    },
  },
};
